import editStrategiesReducer from '../state/edit-strategy-slice'

export const strategiesReducer = {
  editStrategies: editStrategiesReducer
}
